import React from 'react';
import './ImageCard.scss'; // Make sure to create a SASS file with this name
import { BsEnvelopeCheckFill } from "react-icons/bs";

const ImageCard = () => {

  return (
    <div className="image-card">
      <div className="text-top">Your text here</div>
       <BsEnvelopeCheckFill className='bs' />
      <div className="text-bottom">Loading...</div>
    </div>
  );
};

export default ImageCard;
